import '@shoelace-style/shoelace/dist/components/dialog/dialog.js';

const setupDialog = () => {
	const dialogs = document.querySelectorAll('[data-dialog]');
	dialogs.forEach(dialog => {
		const openTrigger = document.querySelector(`[data-dialog-trigger="${dialog.dataset.dialog}"]`);
		if (openTrigger) {
			openTrigger.addEventListener('click', () => dialog.show());
		}

		const closeTrigger = dialog.querySelector('[data-dialog-close]');
		if (closeTrigger) {
			closeTrigger.addEventListener('click', () => dialog.hide());
		}

		const newWindowTrigger = dialog.querySelector('[data-dialog-new-window]');
		if (newWindowTrigger) {
			newWindowTrigger.addEventListener('click', () => {
				window.open(newWindowTrigger.dataset.dialogNewWindow, '_blank');
				dialog.hide();
			});
		}
	});
}

export { setupDialog }
